import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  statusChip: {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '14px',
    textTransform: 'uppercase',
    height: 'unset',
    padding: '2px',
    borderRadius: '12px',
  },
  completed: {
    backgroundColor: theme.evPalette.lime[100],
    color: theme.evPalette.lime[800],
  },
  closed: {
    backgroundColor: theme.evPalette.charcoal[400],
    color: theme.evPalette.charcoal[800],
  },
  inProcess: {
    backgroundColor: theme.evPalette.mango[100],
    color: theme.evPalette.mango[800],
  },
  created: {
    backgroundColor: theme.evPalette.mango[100],
    color: theme.evPalette.mango[800],
  },
  actionNeeded: {
    backgroundColor: theme.evPalette.raspberry[100],
    color: theme.evPalette.raspberry[700],
  },
  checkEmail: {
    backgroundColor: theme.evPalette.raspberry[700],
    color: theme.evPalette.raspberry[100],
  },
  buildingChip: {
    backgroundColor: theme.evPalette.charcoal[300],
    color: theme.evPalette.charcoal[900],
    fontSize: '10px',
    lineHeight: '10px',
    height: 'unset',
    padding: '4px 8px',
    borderRadius: '24px',
    '&>span': {
      '&>em': {
        textTransform: 'uppercase',
        fontWeight: 600,
        fontStyle: 'normal',
      },
      '&>span': {
        color: theme.evPalette.charcoal[900],
        fontWeight: 400,
      },
      overflow: 'visible',
      fontWeight: 400,
      display: 'flex',
      columnGap: '8px',
    },
  },
  sitemapLink: {
    backgroundColor: 'white',
    color: theme.evPalette.ocean[600],
    fontSize: '10px',
    lineHeight: '12px',
    padding: '4px 8px',
    height: 'unset',
    width: 'fit-content',
    borderRadius: '24px',
    overflow: 'visible',
    fontWeight: 400,
    display: 'flex',
    columnGap: '8px',
    alignItems: 'center',
    textDecoration: 'none',
    border: `1px solid ${theme.evPalette.ocean[600]}`,
    '&>em': {
      textTransform: 'uppercase',
      fontWeight: 600,
      fontStyle: 'normal',
      color: theme.evPalette.charcoal[900],
    },
    '&>span': {
      color: theme.evPalette.charcoal[900],
      fontWeight: 400,
    },
  },
  identifyBtn: {
    backgroundColor: theme.evPalette.salt[100],
    borderColor: theme.evPalette.charcoal[300],
    padding: '4px 12px 4px 12px',
  },
  indentifyBtnLabel: {
    columnGap: '8px',
    padding: 0,
    alignItems: 'center',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '19px',
    textTransform: 'none',
  },
  skeletonLoader: {
    borderRadius: '6px',
    flexShrink: 0,
  },
  loaderSizeMedium: {
    width: '3.58vw',
    height: '27px',
    '@media (min-width: 640px)': {
      width: '5.78vw',
      height: '24px',
    },
  },
  productAddressCell: {
    minWidth: '250px',
    maxWidth: '350px',
  },
  subscriptionDetailsCell: {
    minWidth: '210px',
    maxWidth: '250px',
  },
}));
